import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, OnDestroy, OnInit, ViewChild, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { values } from 'lodash-es';
import { forkJoin, Subscription, take, zip } from 'rxjs';
import { DfMeDropdownComponent } from '../../../shared/components/df-me-dropdown/df-me-dropdown.component';
import {
  JSONExportHeader,
  JSONExportService,
} from '../../../shared/_services/JSONExport.service';
import { DiscModalViewerComponent } from '../../shared/components/disc-modal-viewer/disc-modal-viewer.component';
import { StmtIdBtnService } from '../../shared/components/stmt-id-btn/stmt-id-btn.service';
import { DSTSharedService } from '../../shared/dst-shared.service';
import { DSTChildFormState } from '../../shared/models/dst-child-form-state.model';
import { DSTStatement } from '../../shared/models/dst-statement.model';
import {
  CreateDisclosureService,
  DSTTaxYear,
} from '../../statement-tracker/create-disclosure/create-new/create-disclosure.service';
import { DSTDynamicComponentResolverService } from '../../statement-tracker/create-disclosure/shared/dst-dynamic-component-resolver.service';
import { TrackerTabsService } from '../../statement-tracker/tracker-tabs.service';
import { ReportsService } from '../reports.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
} from '../../../shared/workspace-element-context';
import {
  buildDstTaxYearItems,
  resolveDstTaxYearFromEvent,
  setDstTaxYearAriaLabel,
  syncDstTaxYearItem
} from '../../shared/utils/dst-tax-year-appkit.support';
import { getAppkitDropdownSelection } from '../../../shared/utils/appkit-dropdown.util';

@Component({
    selector: 'gtw-count-by-business',
    templateUrl: './count-by-business.component.html',
    styleUrls: [
        '../../shared/styles/dst-shared.scss',
        './count-by-business.component.scss',
    ],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CountByBusinessComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private contextApplied = false;

  @ViewChild(DiscModalViewerComponent)
  modalViewerComponent!: DiscModalViewerComponent;
  @ViewChild(DfMeDropdownComponent)
  dfMeDropdownComponent!: DfMeDropdownComponent;
  data: any[] = [];
  
  loading: boolean = false;
  isLoadingExcel: boolean = false;
  taxyearLoaded: boolean = false;
  excelExportFileName: string;
  scrollBarHidden: boolean = false;

  taxYears: DSTTaxYear[] = [];
  previousTaxYears: DSTTaxYear[] = [];
  taxYearItems: { value: number; label: string }[] = [];
  previousTaxYearItems: { value: number; label: string }[] = [];
  selectedTaxYearItem: any = null;
  selectedPreviousTaxYearItem: any = null;
  taxYear: any ;
  previousTaxYear: any;
  selectedBusinessObj: any;
  businessesNameObj: any[] = [];
  // Appkit's dropdown does not narrow its own list while searching; it emits the
  // matches and expects them to be bound back, so the control renders this one.
  businessDropdownList: any[] = [];
  currentYear: Number | undefined;
  selectedMes: string = '';
  activeRow!: DSTStatement;
  showModalViewer: boolean = false;
  private onDisCancelSubs!: Subscription;

  constructor(
    private cDSerivce: CreateDisclosureService,
    private dstSharedService: DSTSharedService,
    private stmtIdBtnService: StmtIdBtnService,
    private trackerTabsService: TrackerTabsService,
    private dCRService: DSTDynamicComponentResolverService,
    private jsonExportService: JSONExportService,
    private reportsService: ReportsService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {
    this.excelExportFileName =
      'Reports-Count_By_Business_' +
      this.dstSharedService.getExcelExportDateString();
    // local test only
    // this.dstSharedService.setBaseURLs({
    //   api: '/gtw',
    //   custom: '/custom',
    //   admin: '/admin',
    //   efile: '/gtw-efile-api',
    //   pdfEngine: '/pdf-engine',
    //   bulkPdfEngine: '/bulk-pdf-engine',
    // });
    // this.dstSharedService.setClientKey('0');
    // this.dstSharedService.setDSTUser('400368836', 2);
    // this.dstSharedService.setS3uploadButtonAccessUsers(['400368836']);
    // this.dstSharedService.setTaxYearScenario('2020', '40');
  }

  ngOnInit(): void {
    // this.dstSharedService.setDSTUser('400368836', 2);

    //local test only
    // const getTaxYears$ = this.cDSerivce.getTaxYears();

    // zip(getTaxYears$)
    //   .pipe(take(1))
    //   .subscribe((data) => {
    //     this.taxYears = data[0];
    //     this.setTaxYear('2020');
    //     this.previousTaxYears = this.taxYears.filter((x) => x.text<this.taxYear.text);
    //     this.previousTaxYear = this.previousTaxYears[0];
    //     this.loading = true;
    //     this.reportsService.loadBusinesses(this.taxYear?.text.toString()!, this.previousTaxYear?.text.toString()!)
    //       .subscribe((result: any) => {
    //         console.log('Testing : ', result);
    //         this.businessesNameObj = result;
    //         this.loading = false;
    //       });
    //   });


    this.onDisCancelSubs = this.dCRService.onDisclosureCancel.subscribe(() => {
      this.trackerTabsService.destroyModalTab();
      this.showModalViewer = false;
    });

    this.applyWorkspaceContext();
    this.onDisCancelSubs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.onDisCancelSubs?.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    if (this.contextApplied) return;
    try {
      const gc = generalConfigFromGlobal(this.gtwGlobal);
      const gp = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
      const user = this.gtwApp.USER_SETTINGS?.user || {};
      const clientKey = String(user.client?.client_key || user.client_key || '');
      const ssoId = String(user.sso_id || '');
      const roleLevel = Number(this.gtwWorkspace.workspaceFactory?.activeScreen?.parent?.access_level || 0);
      const taxYear = String(gp.tax_year || '');
      const scenario = String(gp.scenario || '');

      if (!clientKey && !ssoId) return;
      this.contextApplied = true;

      this.dstSharedService.setClientKey(clientKey);
      this.dstSharedService.setDSTUser(ssoId, roleLevel);
      this.dstSharedService.setSystemLockUnlockStatus(false, roleLevel);
      this.dstSharedService.setTaxYearScenario(taxYear, scenario);
      this.dstSharedService.setBaseURLs(gc);

      this.loading = true;
      const getTaxYears$ = this.cDSerivce.getTaxYears();
      zip(getTaxYears$)
        .pipe(take(1))
        .subscribe({
          next: (data) => {
            this.taxYears = data[0];
            this.setTaxYear(taxYear);
            this.refreshPreviousTaxYearSelection();
            this.loadBusinessesForSelectedYears();
          },
          error: () => {
            this.loading = false;
          },
        });
    } catch (e) {
      this.dstSharedService.showAlert('error', 'Missing context, please contact system administrator for assistance!');
    }
  }



  onTaxYearChange(): void {
    this.taxyearLoaded = true;
    this.refreshPreviousTaxYearSelection();
    this.loadBusinessesForSelectedYears();
  }

  private refreshPreviousTaxYearSelection(): void {
    if (!this.taxYear?.text) {
      this.previousTaxYears = [];
      this.previousTaxYear = undefined;
      this.previousTaxYearItems = [];
      this.selectedPreviousTaxYearItem = null;
      return;
    }

    this.previousTaxYears = this.taxYears.filter((x) => x.text < this.taxYear.text);
    this.previousTaxYear = this.previousTaxYears[0];
    this.previousTaxYearItems = buildDstTaxYearItems(this.previousTaxYears);
    this.selectedPreviousTaxYearItem = syncDstTaxYearItem(
      this.previousTaxYearItems,
      this.previousTaxYear
    );
  }

  onPreviousTaxYearChange(): void {
    this.taxyearLoaded = true;
    this.loadBusinessesForSelectedYears();
  }

  private loadBusinessesForSelectedYears(): void {
    if (!this.taxYear?.text || !this.previousTaxYear?.text) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.selectedBusinessObj = [];
    this.reportsService
      .loadBusinesses(this.taxYear.text.toString(), this.previousTaxYear.text.toString())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result: any) => {
          // Appkit renders the option list itself, reading the checkbox and the
          // accessibility role off each item.
          this.businessesNameObj = (result || []).map((business: any) => ({
            ...business,
            showCheckbox: true,
            role: 'checkbox',
          }));
          this.businessDropdownList = [...this.businessesNameObj];
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  setTaxYear(taxYear: string): void {
    this.taxYear = this.taxYears.find((item: any) => {
      return item.text.toString() === taxYear;
    });
    this.taxYearItems = buildDstTaxYearItems(this.taxYears);
    this.selectedTaxYearItem = syncDstTaxYearItem(this.taxYearItems, this.taxYear, taxYear);
    this.taxyearLoaded = true;
  }

  onTaxYearChanged(event: any): void {
    const matched = resolveDstTaxYearFromEvent(event, this.taxYears);
    if (matched) {
      this.taxYear = matched;
      this.selectedTaxYearItem = syncDstTaxYearItem(this.taxYearItems, this.taxYear);
      this.onTaxYearChange();
    }
  }

  onPreviousTaxYearChanged(event: any): void {
    const matched = resolveDstTaxYearFromEvent(event, this.previousTaxYears);
    if (matched) {
      this.previousTaxYear = matched;
      this.selectedPreviousTaxYearItem = syncDstTaxYearItem(this.previousTaxYearItems, this.previousTaxYear);
      this.onPreviousTaxYearChange();
    }
  }

  onTaxYearSelectItem(event: any): void {
    const selected = getAppkitDropdownSelection(event);
    if (selected) this.selectedTaxYearItem = selected;
  }

  onPreviousTaxYearSelectItem(event: any): void {
    const selected = getAppkitDropdownSelection(event);
    if (selected) this.selectedPreviousTaxYearItem = selected;
  }

  setTaxYearAriaLabel(item: any): string {
    return setDstTaxYearAriaLabel(item);
  }

  selectedMeChanged(selected: string): void {
    this.selectedMes = selected;
  }

   private changeScrollBarStyling(): void {
    const cdkScrollerEles: HTMLCollectionOf<Element> =
      document.getElementsByTagName('cdk-virtual-scroll-viewport');
    if (cdkScrollerEles.length) {
      this.scrollBarHidden =
        (cdkScrollerEles[0] as HTMLElement).scrollHeight >
        (cdkScrollerEles[0] as HTMLElement).offsetHeight
          ? false
          : true;
    } else {
      this.scrollBarHidden = true;
    }
  }

 
  afterModalClosed(): void {
    this.trackerTabsService.destroyModalTab();
    this.showModalViewer = false;
  }

  onBusinessFilterResult(event: any): void {
    this.businessDropdownList = event?.result || [];
  }

  isFormValid(): boolean {
    if (!this.selectedBusinessObj?.length) {
      this.dstSharedService.showAlert('error', 'Please select Business Name');
      return false;
    }
    return true;
  } 

  exportToExcel(): void {
    
    if (!this.isFormValid()) {
      return;
    } else {
      this.isLoadingExcel = true;
      console.log(this.selectedBusinessObj)
      var selectedBusinessesString = '';
      this.selectedBusinessObj.forEach((x: any , index: any) => {
        console.log(x);
        if(index === this.selectedBusinessObj.length -1){
          selectedBusinessesString = selectedBusinessesString + x.key.toString();
        }else{
          selectedBusinessesString = selectedBusinessesString + x.key.toString()+', ';
        }
        
      });
      //console.log(selectedBusinessesString);
      //console.log(this.taxYear.text.toString(), this.previousTaxYear.text.toString(), selectedBusinessesString);

      // forkJoin issues all three requests in parallel and waits for the
      // last value of each. This replaces the previous 3-level nested
      // subscribe chain that serialised the requests for no good reason.
      forkJoin({
        result1: this.reportsService.loadStatementsByYearandBusiness(this.taxYear.text.toString(), selectedBusinessesString),
        result2: this.reportsService.loadStatementsByYearandBusiness(this.previousTaxYear.text.toString(), selectedBusinessesString),
        result3: this.reportsService.loadCountByBusiness(this.taxYear.text.toString(), this.previousTaxYear.text.toString(), selectedBusinessesString),
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(({ result1, result2, result3 }) => {
                var headersMaps: any[] = [];
                const headerMap: JSONExportHeader[] = [
                  {
                    field: 'STATEMENTID',
                    header: 'Statement Id',
                  },
                  {
                    field: 'TAXYEAR',
                    header: 'Year',
                  },
                  {
                    field: 'FORM_TYPE',
                    header: 'Form Type',
                  },
                  {
                    field: 'STATEMENTNAME',
                    header: 'Disclosure',
                  },
                  {
                    field: 'PRIMARYLEID',
                    header: 'Primary LEID',
                  },
                  {
                    field: 'SECONDARYLEID',
                    header: 'Secondary LEID',
                  },
                  {
                    field: 'PRIMARYENTITY',
                    header: 'Primary Name',
                  },
                  {
                    field: 'SECONDARYENTITY',
                    header: 'Secondary Name',
                  },
                  {
                    field: 'PRIMARYBUSINESS',
                    header: 'Primary Business',
                  },
                  {
                    field: 'SECONDARYBUSINESS',
                    header: 'Secondary Business',
                  },
                  {
                    field: 'BRANCHLEID',
                    header: 'Branch LEID',
                  },
                  {
                    field: 'CREATEDBY',
                    header: 'Created By',
                  },
                  {
                    field: 'MODIFIEDBY',
                    header: 'Modified By',
                  },
                  {
                    field: 'CREATEDON',
                    header: 'Created On',
                  },
                  {
                    field: 'MODIFIEDON',
                    header: 'Modified On',
                  },
                  {
                    field: 'ISFILED',
                    header: 'Is Filed',
                  },
                  {
                    field: 'ISQAR',
                    header: 'Is QAR',
                  },
                  {
                    field: 'DCNNAME',
                    header: 'DCN',
                  },
                  {
                    field: 'SIGNATUREFLAG',
                    header: 'Signature Flag',
                  },
                  {
                    field: 'ELECTIONFLAG',
                    header: 'Election Flag',
                  },
                ];
            
                const headerMap_sheet3: JSONExportHeader[] = [
                  {
                    field: 'FORMID',
                    header: 'Form Id',
                  },
                  {
                    field: 'FORM_TYPE',
                    header: 'Form Type',
                  },
                  {
                    field: 'STMTTYPE',
                    header: 'Stmt Type',
                  },
                  {
                    field: 'FORMNAME',
                    header: 'Form Name',
                  },
                  {
                    field: 'PRIORYEARCOUNT',
                    header: this.previousTaxYear.text.toString()+' Year Count',
                  },
                  {
                    field: 'CURRENTYEARCOUNT',
                    header: this.taxYear.text.toString()+' Year Count',
                  },
                ];
            
                headersMaps.push(headerMap, headerMap, headerMap_sheet3);
            
                this.jsonExportService.exportToExcelCountByBusiness(
                  this.excelExportFileName, [result1, result2, result3], headersMaps
                );
                this.isLoadingExcel = false;
      });
    }
  }

  

 
}
